import React from 'react';
import withRouter from '../../lib/router/withRouter';

import PageTemplate from '../../components/template/PageTemplate';
import ProductDetailWrap from '../../views/product/detail/ProductDetailWrap';
import useToastMsg from '../../hooks/common/useToastMsg';
import useProductDetail from '../../hooks/queries/product/useProductDetail';
import useProductCustomAttributes from '../../hooks/product/useProductCustomAttributes';
import { INIT_PRODUCT_DETAIL_MODEL } from '../../store/modules/product/models';
import productToastMsg from '../../constants/service/toastMsg/productToastMsg';
import { PRODUCT_DETAIL_PAGE_TYPE, PRODUCT_PAGE_NAME } from '../../constants/service/app/productConstants';
import { extractErrorMessage } from '../../lib/utils/checkErrorResponse';

const ProductEdit = ({ match }) => {
  const toastMsg = useToastMsg();
  const productId = parseInt(match.params.id, 10);

  const { data } = useProductDetail(productId, {
    initialData: INIT_PRODUCT_DETAIL_MODEL,
    onSuccess: () => {
      toastMsg.success(productToastMsg.GET_PRODUCT_INFO_REQUEST_SUCCESS);
    },
    onError: (error) => {
      toastMsg.error(extractErrorMessage(error));
    },
  });

  const customAttributes = useProductCustomAttributes({ productId });

  return (
    <PageTemplate pageName={PRODUCT_PAGE_NAME.PRODUCT_EDIT}>
      <ProductDetailWrap
        pageType={PRODUCT_DETAIL_PAGE_TYPE.EDIT}
        data={{ ...data, customFieldDefinitions: customAttributes }}
      />
    </PageTemplate>
  );
};

export default withRouter(ProductEdit);
